import { AuthRole } from '@/enums/roles';
import Overview from '@/modules/rie/views/formTemplates/Overview.vue';
import type { RouteRecordRaw } from 'vue-router';

const path = '/modules/rie/vragenlijst-sjablonen';
const moduleName = 'RI&E';

const formTemplateRoutes: readonly RouteRecordRaw[] = [
    {
        path: path,
        name: 'formTemplates',
        component: Overview,
        meta: {
            pageTitle: `${moduleName} | Vragenlijst sjablonen`,
            roles: [AuthRole.SecurityOfficer]
        }
    }
];

export default formTemplateRoutes;
